module.exports = __webpack_public_path__ + "static/media/Resume.33597771.pdf";